<template>
  <div>
    <template v-if="isEdit">
      <div class="caption">
        {{ $t('Realname') }}
      </div>

      <div class="form-control">
        <input v-model="name" type="text" />
      </div>

      <div class="caption">
        {{ $t('Address') }}
      </div>

      <div class="form-control">
        <textarea v-model="address" rows="3" style="resize: vertical"></textarea>
      </div>

      <div class="caption">
        {{ $t('Tel.') }}
      </div>

      <div class="form-control">
        <input v-model="tel" type="tel" maxlength="10" />
      </div>

      <v-btn outline small color="primary" @click="cancelChange">
        {{ $t('cancel') }}
      </v-btn>
      <v-btn depressed small color="primary" @click="saveChange">
        {{ $t('Save') }}
      </v-btn>
    </template>

    <template v-else>
      <nl2br tag="span" :text="value" :title="value" style="word-wrap: break-word" />
      <div style="display: inline-block">
        <v-btn v-if="showEdit" flat fab small color="primary" class="ma-0" @click="isEdit = true">
          <v-icon>edit</v-icon>
        </v-btn>
        <template v-if="hasCopy">
          <v-tooltip v-model="showCopy" bottom color="success">
            <template #activator="{}">
              <v-btn
                v-clipboard:copy="value"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError"
                flat
                fab
                small
                class="ma-0"
                color="primary"
              >
                <v-icon>file_copy</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Copied') }}</span>
          </v-tooltip>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import Nl2br from 'vue-nl2br'
export default {
  components: {
    Nl2br
  },
  props: {
    value: {},
    hasCopy: {},
    showEdit: {
      default: true
    }
  },
  data() {
    return {
      isEdit: false,
      name: '',
      address: '',
      tel: '',
      showCopy: false,
      cached_info: {}
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.formatInfo(newVal)
        this.cached_info = newVal
      }
    }
  },
  mounted() {
    this.formatInfo(this.value)
    this.cached_info = this.value
  },
  methods: {
    formatInfo(val) {
      try {
        const info = val.split(' , ')
        if (info.length >= 3) {
          this.name = info[0].trim()
          this.tel = info[info.length - 1].trim()
          delete info[0]
          delete info[info.length - 1]
          this.address = info.join(' ').trim()
        }
      } catch (error) {
        this.address = val
      }
    },
    cancelChange() {
      this.isEdit = false
      this.formatInfo(this.cached_info)
    },
    saveChange: function () {
      this.isEdit = false
      const info = [this.name, this.address, this.tel]
      this.$emit('input', info.join(' , '))
      this.$emit('edited')
    },
    onCopy() {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onCopyError() {}
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/EditAddress.vue